import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { channelInputCleared } from 'gcs-common/slices/messageInput/messageInputSlice';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import forwardIcon from '../../img/forward_white.svg';
import closeWhiteIcon from '../../img/x_white.svg';
import styles from './styles.module.scss';

interface ForwardChannelListItemProps {
  forwardingFromEts?: boolean | false;
}

const ForwardChannelListHeader = (props: ForwardChannelListItemProps) => {
  const { forwardingFromEts } = props;
  const selectedChannelId = useSelector(getSelectedChannelId);
  const navigate = useNavigate();
  const { routeTicketId } = useParams();
  const ticketId = routeTicketId ?? '';
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(channelInputCleared({ channelId: selectedChannelId }));
  }, [dispatch, selectedChannelId]);

  const goToTicket = () => {
    navigate(CHAT_ROUTES.TICKET(ticketId));
  };
  return (
    <div className={styles.header}>
      <img src={forwardIcon} className={styles.fileTypeLogo} alt="main-preview-img" />
      <div className={styles.headerText}>Nachricht weiterleiten</div>
      <button className={styles.closeButton} type="button" onClick={forwardingFromEts ? goToTicket : onClose}>
        <img src={closeWhiteIcon} alt="main-preview-close" />
      </button>
    </div>
  );
};

ForwardChannelListHeader.propTypes = {};

export default ForwardChannelListHeader;
